import React from 'react';

import { useClassnames, visuallyHidden } from '@lumapps/classnames';
import { Text } from '@lumapps/lumx/react';
import { useTranslate } from '@lumapps/translations';

import { LUMX_CHAT } from '../../keys';
import { ChatMessageBubble } from '../ChatMessageBubble';
import { ChatTypingAnimation } from '../ChatTypingAnimation';

import './index.scss';

const CLASSNAME = 'lumx-chat-message-loading';

/**
 * Loader displayed when an answer or message is awaited in a chat feature
 * @family Chat
 * @param ChatMessageLoadingProps
 * @returns ChatMessageLoading
 */
export const ChatMessageLoading: React.FC = () => {
    const { translateKey } = useTranslate();
    const { block, element } = useClassnames(CLASSNAME);

    return (
        <ChatMessageBubble className={block()} type="received">
            <Text as="p" className={visuallyHidden()}>
                {translateKey(LUMX_CHAT.INCOMING_MESSAGE)}
            </Text>
            <ChatTypingAnimation className={element('animation')} />
        </ChatMessageBubble>
    );
};
